// Shared in-app navigation guard.
// Lets a page (e.g. Edit Profile) intercept navigation triggered from other
// components (e.g. the navbar CMOverse.ai logo) so it can warn about unsaved
// changes before the user leaves.
//
// The caller hands over its `proceed` callback — the ORIGINAL navigation plus
// all of the caller's teardown. On "Discard" the intercepting page runs that
// exact callback, so leaving via the guard produces the same app state as a
// direct click. A bare navigate() here would skip the caller's cleanup.

let guardFn = null;

export const registerNavigationGuard = (fn) => {
  guardFn = fn;
};

export const unregisterNavigationGuard = () => {
  guardFn = null;
};

// Returns true when navigation was intercepted — the caller MUST NOT navigate.
// The guard takes ownership of `proceed` and runs it later (after the user
// confirms discard). Returns false when no guard is registered or the page has
// nothing to warn about, in which case the caller proceeds normally.
export const runNavigationGuard = (path, proceed) => {
  if (typeof guardFn === "function") {
    return guardFn(path, proceed) === true;
  }
  return false;
};
